import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectAssignment } from '@app/models/time-tracking/project-assignment.model';
import { Translatable } from '@app/types/translatable.type';
import { Employee } from '@models/employee/employee.model';
import { ProjectOwnership } from '@models/time-tracking/project-ownership.model';
import { minutesToHoursAndMinutes } from '@time-tracking/functions/minutes-to-hours-and-minutes';

@Component({
    templateUrl: './my-projects-show.template.html',
})
export class MyProjectsShowView {
    projectAssignment: ProjectAssignment;
    owners: Employee[] = [];

    approvalFlows: { [key: string]: Translatable } = {
        automatic: 'time-tracking.approvalFlows.automatic',
        manager: 'time-tracking.approvalFlows.manager',
        owner: 'time-tracking.approvalFlows.owner',
    };

    constructor(private route: ActivatedRoute) {
        this.projectAssignment = this.route.snapshot.data.models.get('projectAssignment');

        this.owners = this.projectAssignment.project.projectOwnerships.map(
            (projectOwnership: ProjectOwnership) => projectOwnership.owner
        );
    }

    totalApprovedHours(): string {
        return minutesToHoursAndMinutes(this.projectAssignment.timesheetsApprovedSumMinutes);
    }

    hasOwners(): boolean {
        return this.owners.length !== 0;
    }
}
